import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import styles from "./Bonus.scss";

const BonusText = forwardRef(({ children, ...restProps }, ref) => (
  <span ref={ref} className={styles.text} {...restProps}>
    {children}
  </span>
));

BonusText.displayName = "TariffTile.BonusText";

BonusText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default BonusText;
